import React from 'react';
import { Area } from 'react-easy-crop/types';
import { Dialog, DialogActions, DialogTitle as MUIDialogTitle } from '@mui/material';

import { withStyles } from 'tss-react/mui';

import { Button } from '../../../Button';
import { ImageCropper } from './image-cropper.component';
import { getCroppedImg } from './image-cropper.utils';


export type ImageCropperModalProps = {
  open: boolean;
  title: string;
  imageUrl: string;
  onClose: () => void;
  onFileCrop: (url: string) => void;
};

const DialogTitle = withStyles(MUIDialogTitle, {
  root: {
    '& .MuiTypography-root': {
      fontWeight: 800,
    }
  }
});


export const ImageCropperModal: React.FC<ImageCropperModalProps> = (props) => {
  const [ loading, setLoading ] = React.useState(false);
  const [ cropArea, setCropArea ] = React.useState<Area>();
  const onCropComplete = React.useCallback((croppedArea, croppedAreaPixels) => {
    setCropArea(croppedAreaPixels);
  }, []);

  const handleSaveClick = async () => {
    try {
      setLoading(true);
      if (cropArea) {
        const croppedImage = await getCroppedImg(props.imageUrl, cropArea);

        if (croppedImage) {
          props.onFileCrop?.(croppedImage);
        }

        setLoading(false);
        props.onClose();
      }
    } catch(e) {
      setLoading(false);
      throw e;
    }
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm" scroll="body">
      <DialogTitle>{props.title}</DialogTitle>
      <ImageCropper
        imageUrl={props.imageUrl}
        onCropComplete={onCropComplete}
      />
      <DialogActions>
        <Button color="secondary" variant="text" onClick={props.onClose} disabled={loading}>Cancel</Button>
        <Button color="secondary" variant="contained" onClick={handleSaveClick} disabled={loading}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};
